import { NgTemplateOutlet } from '@angular/common';
import { Component, input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { cloneAbstractControl } from 'src/lib/utilities/forms';
import { ModalMoverComponent } from '../../../../global/modal-mover/modal-mover.component';
import { PaginationTableColumnDirective } from '../../children/pagination-table-column.directive';
import { PaginationTableFormModalCustomDirective } from '../../children/pagination-table-form-modal-custom.directive';

@Component({
	selector: 'ae-pagination-table-search-modal',
	templateUrl: './pagination-table-search-modal.component.html',
	styleUrls: ['./pagination-table-search-modal.component.scss'],
	imports: [
		FormsModule,
		ModalMoverComponent,
		NgTemplateOutlet,
		ReactiveFormsModule,
	],
})
export class PaginationTableSearchModalComponent<T> implements OnInit {
	readonly formGroup = input.required<FormGroup>();
	readonly columnTemplates =
		input.required<PaginationTableColumnDirective<T>[]>();
	readonly customFormTemplate =
		input.required<PaginationTableFormModalCustomDirective>();

	public clonedFormGroup: FormGroup;

	constructor(public activeModal: NgbActiveModal) {}

	ngOnInit(): void {
		this.clonedFormGroup = cloneAbstractControl(this.formGroup());
	}

	public searchableColumns = () => {
		return this.columnTemplates().filter(
			(x: PaginationTableColumnDirective<T>) => {
				return x.searchTemplate != null;
			},
		);
	};

	public accept = () => {
		this.activeModal.close(this.clonedFormGroup);
	};

	public cancel = () => {
		this.activeModal.dismiss();
	};
}
